<style>
#analysis {
  height: 84px;
}
.inactive {
  pointer-events: none !important;
  color: darkgrey !important;
}
.textElement--centered {
  display: flex;
  justify-content: center;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <!-- <div class="group">
      <button class="ribbon-button" @click="show('legendModal')" title="Legenda mapy">
        <span class="icon">
          <v-icon>layers</v-icon>
        </span>
        <span class="caption">WARSTWY</span>
      </button>
    </div> -->
    <div class="group">
      <div class="container__group--rows">
        <div class="textElement--centered  ribbon__row border--bottom">
          <p class="caption">Analiza zasuw</p>
        </div>
        <div class="ribbon__row border--bottom">
          <div
            class="ribbon-button ribbon__row--flex"
            @click="toggleBreak"
            title="Wskaż miejsce, dla którego chcesz znaleźć listę zasuw do zamknięcia"
          >
            <span class="icon">
              <v-icon small>near_me</v-icon>
            </span>
            <button class="caption">Lokalizuj</button>
          </div>
          <div
            class="ribbon-button ribbon__row--flex"
            :class="{ inactive: !isLocalized}"
            @click="computeCutoff"
            title="Wykonaj analizę zasuw do zamknięcia"
          >
            <span class="icon">
              <v-icon small>play_arrow</v-icon>
            </span>
            <button class="caption">Wykonaj</button>
          </div>
          <div
            class="ribbon-button ribbon__row--flex"
            :class="{ inactive: isInactive}"
            @click="clearCutoff()"
            title="Zakończ analizę zasuw"
          >
            <span class="icon">
              <v-icon small>remove_circle</v-icon>
            </span>
            <button class="caption">Wyczyść</button>
          </div>
          <div
            class="ribbon-button ribbon__row--flex"
            :class="{ inactive: isInactive}"
            title="Wygeneruj raport dotyczący przeprowadzonej analizy zasuw"
            @click="generateRaport"
          >
            <span class="icon">
              <v-icon small>event_note</v-icon>
            </span>
            <button class="caption">Raport</button>
          </div>
          <div
            class="ribbon-button ribbon__row--flex"
            :class="{ inactive: isInactive}"
            title="Wysłanie wiadomości SMS odbiorcom"
            @click="sendSMS"
          >
            <span class="icon">
              <v-icon small>phonelink_ring</v-icon>
            </span>
            <button class="caption">Powiadom odbiorców</button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="group">
      <button
        class="ribbon-button"
        @click="show('generateAd')"
        title="Generowanie ogłoszenia o przerwie w dostawie wody"
      >
        <span class="icon">
          <v-icon>assignment_late</v-icon>
        </span>
        <span class="caption">Ogłoszenia</span>
      </button>
    </div> -->

    <!-- <div class="group">
      <div class="container__group--rows">
        <div class="ribbon__row border--bottom">
          <p class="caption">Analiza przestrzenna</p>
        </div>
        <div class="ribbon__row border--bottom">
          <div class="ribbon-button ribbon__row--flex" @click="spatialAnalysis('buffor')">
            <span class="icon">
              <v-icon small>vignette</v-icon>
            </span>
            <button class="caption">Bufory</button>
          </div>

          <div class="ribbon-button ribbon__row--flex" @click="spatialAnalysis('intersection')">
            <span class="icon">
              <v-icon small>crop</v-icon>
            </span>
            <button class="caption">Przecięcia</button>
          </div>

          <div
            class="ribbon-button ribbon__row--flex"
            style="padding-right: 0px;"
            :title="dropdownSpatialAnalysisButtons[currentSpatialAnalysisButton].tooltip"
            @click.self="spatialAnalysis(currentSpatialAnalysisButton)"
          >
            <span class="icon">
              <v-icon small>room</v-icon>
            </span>
            <button
              class="caption"
              @click.self="spatialAnalysis(currentSpatialAnalysisButton)"
            >Inne...</button>
            <v-menu offset-y>
              <v-btn slot="activator" flat icon depressed small>
                <v-icon small>arrow_drop_down</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(button, key, index) in dropdownSpatialAnalysisButtons"
                  :key="`${key}-${index}`"
                  @click="currentSpatialAnalysisButton = key; spatialAnalysis(key);"
                  :value="key == currentSpatialAnalysisButton"
                  active-class="primary primary--text text--lighten-4"
                >
                  <v-list-tile-title v-text="button.text"></v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
    </div> -->

    <div class="group">
      <button
        class="ribbon-button"
        @click="analysisWaterCutting"
        title="Analiza rozbioru wody"
      >
        <span class="icon">
          <v-icon>poll</v-icon>
        </span>
        <span class="caption">Analiza rozbioru wody</span>
      </button>
    </div>

    <div class="group">
      <button
        class="ribbon-button"
        @click="waterUsageInZone"
        title="Rozbiór wody w strefach"
      >
        <span class="icon">
          <v-icon>poll</v-icon>
        </span>
        <span class="caption">Rozbiór wody w strefach</span>
      </button>
    </div>

    <!-- <div class="group">
      <button class="ribbon-button"
        @click="show('exportStatsModal')"
        >
        <span class="icon">
          <v-icon>insert_chart</v-icon>
        </span>
        <span class="caption">Eksport statystyk</span>
      </button>
    </div> -->

    <div class="group">
      <div class="container__group--rows">
        <div class="ribbon__row border--bottom">
          <div
            class="ribbon-button ribbon__row--flex"
            @click="show('profileNMT')"
            title="Profil podłużny NMT"
          >
            <span class="icon">
              <v-icon small>timeline</v-icon>
            </span>
            <button class="caption">Profil podłużny NMT</button>
          </div>
        </div>
        <div class="ribbon__row border--bottom">
          <div
            class="ribbon-button ribbon__row--flex"
            @click="showProfileModal('junctions')"
            title="Sieć wodociągowa"
          >
            <span class="icon">
              <v-icon small>timeline</v-icon>
            </span>
            <button class="caption">Sieć wod.</button>
          </div>

          <div
            class="ribbon-button ribbon__row--flex"
            @click="showProfileModal('manholes_sewers', true)"
            title="Sieć kanalizacyjna"
          >
            <span class="icon">
              <v-icon small>timeline</v-icon>
            </span>
            <button class="caption">Sieć kan.</button>
          </div>
        </div>
      </div>
    </div>

    <div class="group">
      <div class="container__group--rows">
        <div class="textElement--centered  ribbon__row border--bottom">
          <p class="caption">Wystąpienie zatoru</p>
        </div>
        <div class="ribbon__row border--bottom">
          <div
            class="ribbon-button ribbon__row--flex"
            @click="toggleBreak"
            title="Wskaż miejsce, dla którego chcesz wskazać wystąpienie zatoru"
          >
            <span class="icon">
              <v-icon small>near_me</v-icon>
            </span>
            <button class="caption">Lokalizuj</button>
          </div>
          <div
            class="ribbon-button ribbon__row--flex"
            :class="{ inactive: !isLocalized}"
            @click="computeObstruction"
            title="Wykonaj analizę wystąpienia zatoru"
          >
            <span class="icon">
              <v-icon small>play_arrow</v-icon>
            </span>
            <button class="caption">Wykonaj</button>
          </div>
          <div
            class="ribbon-button ribbon__row--flex"
            :class="{ inactive: isInactive}"
            @click="clearObstruction()"
            title="Usuń znacznik"
          >
            <span class="icon">
              <v-icon small>remove_circle</v-icon>
            </span>
            <button class="caption">Wyczyść</button>
          </div>
        </div>
      </div>
    </div>

    <div class="group">
      <button
        class="ribbon-button"
        @click="$store.commit('setShowDirectionFlows', !showDirectionFlows)"
        :class="{activeBtn : showDirectionFlows}"
        title="Wyświetl kierunki przewodów"
      >
        <span class="icon">
          <v-icon>trending_down</v-icon>
        </span>
        <span class="caption">Wyświetl kierunki ...</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button"
        @click="toogleShowValvesState"
        :class="{activeBtn : showValvesState}"
        title="Szukanie zasuw"
      >
        <span class="icon">
          <v-icon>radio_button_unchecked</v-icon>
        </span>
        <span class="caption">Szukanie zasuw</span>
      </button>
    </div>

    <div
      class="more-hidden"
      id="showMore"
    >
      <a href="#">
        <span class="fa fa-ellipsis-h"></span>
      </a>
      <ul class="hidden-menu"></ul>
    </div>
    <Intersect />
  </vue-custom-scrollbar>
</template>

<script>
import Intersect from "./modals/Intersect";
import CommonComp from "../../shared/CommonComp";
import vueCustomScrollbar from "vue-custom-scrollbar";

//ol
import {transform} from "ol/proj.js";
import {
  LineString,
  Polygon,
  MultiPoint,
  MultiPolygon,
  MultiLineString,
  Point
} from "ol/geom";
import LinearRing from "ol/geom/LinearRing";
import GeometryCollection from "ol/geom/GeometryCollection";
import Feature from "ol/Feature";
import {Vector as VectorLayer} from "ol/layer";
import {GeoJSON} from "ol/format";
import {Vector as VectorSource, Cluster} from "ol/source";

//lodash
import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import filter from "lodash/filter";
import includes from "lodash/includes";
import map from "lodash/map";
import keyBy from "lodash/keyBy";
import template from "lodash/template";
import sum from "lodash/sum";
import mapValues from "lodash/mapValues";
mixin(_, {
  chain,
  filter,
  includes,
  map,
  keyBy,
  template,
  sum,
  mapValues
});
_.value = value;
_.prototype.value = value;

//templates
import templateModalDynamicBase from "../../shared/templateModalDynamicBase.html";
import templateAnalysisBuffer from "./template/templateAnalysisBuffer.html";
import templateAnalysisIntersection from "./template/templateAnalysisIntersection.html";
import templateAnalysisCountInPolygon from "./template/templateAnalysisCountInPolygon.html";
import templateDialogWaterUsageInZones from "./template/templateDialogWaterUsageInZones.html";

//jsts
import OL3Parser from "jsts/org/locationtech/jts/io/OL3Parser";
import {
  Coordinate,
  Geometry as jstsGeometry,
  GeometryFactory
} from "jsts/org/locationtech/jts/geom";
const ol_parser = new OL3Parser();
ol_parser.inject(
  Point,
  LineString,
  LinearRing,
  Polygon,
  MultiPoint,
  MultiLineString,
  MultiPolygon,
  GeometryCollection
);
import {BufferOp} from "jsts/org/locationtech/jts/operation/buffer";
import {RelateOp} from "jsts/org/locationtech/jts/operation/relate";
import STRtree from "jsts/org/locationtech/jts/index/strtree/STRtree";

//<editor-fold defaultstate="collapsed" desc="config jsts geometry">
jstsGeometry.prototype.buffer = function () {
  return BufferOp.bufferOp(this, ...arguments);
};
jstsGeometry.prototype.intersects = function () {
  return RelateOp.intersects(this, ...arguments);
};
jstsGeometry.prototype.contains = function () {
  return RelateOp.contains(this, ...arguments);
};

const fabryka = new GeometryFactory();
//</editor-fold>

export default {
  components: {
    Intersect,
    CommonComp,
    vueCustomScrollbar
  },
  data: () => ({
    isClickable: false,
    pointCoords: [],
    isInactive: true,
    isLocalized: false,
    watermetersSMS: [],

    currentSpatialAnalysisButton: "count_in_polygon",
    dropdownSpatialAnalysisButtons: {
      count_in_polygon: {
        text: "Zlicz w wielokącie",
        tooltip: "Zlicz w wielokącie"
      }
    },

    selectedAnalysLayer: false,
    bufferAnalys: 10,
    selectedAnalysMaskLayer: false,
    layerVisibleAfter: false
  }),
  computed: {
    map() {
      return this.$store.getters.getMap;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    currentBasemap() {
      return this.$store.getters.getCurrentBasemap;
    },
    tableDataActive() {
      return this.$store.getters.getTableDataActive;
    },
    partitionFeatures() {
      const layers = this.map
        .getLayers()
        .item(2)
        .getLayers()
        .getArray();
      for(let l of layers) {
        if(l.get("full_type") === "partitions")
          return l.getSource().getFeatures();
      }
      return [];
    },
    valvesFeatures() {
      const layers = this.map
        .getLayers()
        .item(2)
        .getLayers()
        .getArray();
      for(let l of layers) {
        if(l.get("full_type") === "valves") return l.getSource().getFeatures();
      }
      return [];
    },

    apiURL() {
      return this.$store.getters.getApiURL;
    },

    layers() {
      const self = this;
      const wodkan_layers = _.chain(
        self.map
          .getLayers()
          .item(2) //warstwy wodkan
          .getLayers()
          .getArray()
      )
        .filter(layer =>
          _.includes(["water", "sewer"], layer.get("layer_type"))
        )
        .map(layer => ({
          name: layer.get("full_name"),
          key: layer.get("full_type"),
          type: "wodkan",
          fields: layer.get("fields"),
          geometry_type: layer.get("geometry_type"),
          instance: self.$root.createProxy(layer)
        }))
        .value();

      const user_layers = _.chain(
        self.map
          .getLayers()
          .item(1) //warstwy różne
          .getLayers()
          .item(0) //warstwy użtkownika
          .getLayers()
          .getArray()
      )
        .filter(layer => layer instanceof VectorLayer)
        .map(layer => ({
          name: `WU: ${layer.get("name")}`,
          table: layer.get("table"),
          key: layer.get("full_type"),
          type: "user",
          fields: layer.get("fields"),
          geometry_type: layer.get("geometry_type"),
          instance: self.$root.createProxy(layer)
        }))
        .value();

      const temp_layers = _.chain(
        self.map
          .getLayers()
          .item(1) //warstwy różne
          .getLayers()
          .item(1) //warstwy tymczasowe
          .getLayers()
          .getArray()
      )
        .filter(layer => layer instanceof VectorLayer)
        .map(layer => ({
          name: `T: ${layer.get("name")}`,
          key: layer.get("full_type"),
          type: "temp",
          fields: layer.get("fields"),
          geometry_type: layer.get("geometry_type"),
          instance: self.$root.createProxy(layer)
        }))
        .value();

      return _.keyBy([...wodkan_layers, ...user_layers, ...temp_layers], "key");
    },
    layersList() {
      return Object.values(this.layers);
    },
    layersListGeometry() {
      return _.keyBy(Object.values(this.layers), "geometry_type");
    },

    userLayers() {
      return this.$store.getters.getUserLayers;
    },
    tempLayers() {
      return this.$store.getters.getTempLayers;
    },

    showDirectionFlows() {
      return this.$store.getters.getShowDirectionFlows;
    },
    showValvesState() {
      return this.$store.getters.getShowValvesState;
    },
  },
  watch: {
    userLayers() {
      setTimeout(() => {
        this.updateLayers();
      }, 3000);
    },
    tempLayers() {
      setTimeout(() => {
        this.updateLayers();
      }, 3000);
    }
  },
  methods: {
    updateLayers() {
      this._computedWatchers.layers.update();
      this._computedWatchers.layersList.update();
      this._computedWatchers.layersListGeometry.update();
    },
    toGeommetryType(layer) {
      switch(layer.geometry_type) {
        case "point":
          return "punktowa";
        case "line":
          return "liniowa";
        case "polygon":
          return "powierzchniowa";
      }
    },
    showProfileModal(layer, ignore_data) {
      this.$root.$emit("toggleLayer", layer, true, 'data', true);
      this.$root.$emit("setProfileLayer", layer);
      this.show("profileSWModal");
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    hideTableData() {
      if(this.tableDataActive) {
        this.$store.commit("setTableDataActive", !this.tableDataActive);
      }
    },
    toggleBreak() {
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby zaznaczyć miejsce wykonania analizy"
      );
      this.isClickable = true;
      this.isLocalized = false;
      this.$root.$emit("removeMarker");
      this.map.getViewport().style.cursor = "crosshair";
    },
    clearCutoff() {
      this.$root.$emit("clearCutoff");
      this.$root.$emit("removeMarker");
      this.isInactive = true;
      this.isLocalized = false;
      this.pointCoords = undefined;
      this.watermetersSMS = [];
      this.map.getViewport().style.cursor = "";
      this.hideTableData();
    },
    computeCutoff() {
      this.$root.$emit("showSnackbar", "#2a579a", `Trwa wykonywanie analizy`);
      let transformedCoords = transform(
        [this.pointCoords[0], this.pointCoords[1]],
        "EPSG:2180",
        "EPSG:4326"
      );
      // features from valves
      let valvefFatures = this.valvesFeatures;
      let partitionFeatures = this.partitionFeatures;
      this.$store.dispatch("computeCutoff", transformedCoords).then(res => {
        if(res.status === 200) {
          if(res.data.valves.length > 0) {
            let filteredValves = valvefFatures.filter(feat =>
              res.data.valves.includes(feat.getId())
            );
            let filteredPartitions = partitionFeatures.filter(feat =>
              res.data.partitions.includes(feat.getId())
            );
            this.$root.$emit("showCutoff", [
              filteredValves,
              filteredPartitions
            ]);
            this.$root.$emit(
              "attributionDataIncludesID",
              {
                valves: res.data.valves,
                partitions: res.data.partitions,
                watermeters: _.map(res.data.watermeters, v => v.id),
                pipes: res.data.pipes,
                terminals: res.data.terminals
              },
              "valves"
            );
            this.watermetersSMS = res.data.watermeters.map(v => v.id);
            this.$root.$emit("generateRaport", [this.pointCoords, res.data]);
            this.isInactive = false;
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Brak znalezionych zasuw do zamknięcia"
            );
            this.clearCutoff();
          }
        } else {
          this.$root.$emit("showSnackbar", "red", `${res.data.message}`);
        }
        this.pointCoords = undefined;
      });
    },
    generateRaport() {
      this.show("generateRaport");
    },
    sendSMS() {
      this.$root.$emit("sendWatermetersId", this.watermetersSMS);
      this.show("sendSMS");
    },
    generateAd() {
      this.show("generateAd");
    },

    createSpatialIndex(source) {
      const rTree = new STRtree();

      _.each(source.getFeatures(), feature => {
        const geometry = ol_parser.read(feature.getGeometry());
        const envelope = geometry.getEnvelopeInternal();

        rTree.insert(envelope, {
          geometry,
          feature
        });
      });

      const forEach = (values, callback, opt_this) => {
        let result;
        for(let i = 0, l = values.length; i < l; i++) {
          result = callback.call(opt_this, values[i]);
          if(result) {
            return result;
          }
        }
        return result;
      };

      return {
        getInExtent(envelop) {
          return rTree.query(envelop).toArray();
        },

        getIntersects(geometry) {
          const results = [];
          this.getInExtent(geometry.getEnvelopeInternal()).forEach(d => {
            if(d.geometry.intersects(geometry)) {
              results.push(d);
            }
          });
          return results;
        },

        getContains(geometry) {
          const results = [];
          this.getInExtent(geometry.getEnvelopeInternal()).forEach(d => {
            if(geometry.contains(d.geometry)) {
              results.push(d);
            }
          });
          return results;
        },

        forEachInExtent(envelop, callback, opt_this) {
          return forEach(this.getInExtent(envelop), callback, opt_this);
        },

        forEachIntersects(geometry, callback, opt_this) {
          return forEach(this.getIntersects(geometry), callback, opt_this);
        }
      };
    },

    spatialAnalysisBuffer() {
      const self = this;

      let nameModal;
      const template = _.template(templateModalDynamicBase, {
        interpolate: /%%([\s\S]+?)%%/g
      })({
        content: templateAnalysisBuffer
      });
      self.selectedAnalysLayer = false;
      self.bufferAnalys = 10;
      self.layerVisibleAfter = false;

      const execut = (layerDef, buffer, visible) => {
        const layer = layerDef.instance.__value;
        let source = layer.getSource();
        if(source instanceof Cluster) {
          source = source.getSource();
        }

        console.log(`spatialAnalysisBuffor START`);
        let count = source.getFeatures().length;
        const result = [];
        _.each(source.getFeatures(), (feature, idx) => {
          let geom = ol_parser.read(feature.getGeometry());
          try {
            geom = geom.buffer(buffer);
          } catch(ex) {
            return;
          }
          const new_feature = feature.clone();
          new_feature.setGeometry(ol_parser.write(geom));
          result.push(new_feature);
          if(idx % 100 === 0) {
            console.log(
              `spatialAnalysisBuffor ${(idx / count) * 100}% => ${
              result.length
              }`
            );
          }
        });

        const fields = layerDef.fields.slice();
        const templayer = {
          id: self.$root.generateID(),
          fields,
          geometry_type: "polygon",
          name: `Bufor na '${layerDef.name}'`
        };

        self.$store.commit("addTempLayer", templayer);
        self.$root.$emit("addTempLayer", templayer, result, visible);

        console.log(
          "spatialAnalysisBuffor",
          count,
          result.length,
          templayer.name
        );
        setTimeout(() => {
          self.$root.$emit(
            "showSnackbar",
            "success",
            `Wynikiem jest ${
            result.length
            } obiektów<br/>Warstwa wynikowa to: "${templayer.name}"`
          );
        }, 500);
      };

      self.$modal.show(
        {
          template,
          props: ["title", "buttons", "layersList"],
          data: () => ({
            selectedAnalysLayer: self.selectedAnalysLayer,
            bufferAnalys: self.bufferAnalys,
            layerVisibleAfter: self.layerVisibleAfter
          }),
          methods: {
            updateValue(name, value) {
              if(name in self) {
                self[name] = value;
              }
            }
          }
        },
        {
          title: "Analiza przestrzenna - bufor",
          buttons: [
            {
              title: "ANULUJ",
              handler(event) {
                self.$modal.hide(nameModal);
              }
            },
            {
              title: "WYKONAJ",
              handler(event) {
                self.$modal.hide(nameModal);
                self.$root.$emit(
                  "showSnackbar",
                  "#2a579a",
                  "Wykonywanie analizy, prosze czekać"
                );
                setTimeout(
                  () =>
                    execut(
                      self.selectedAnalysLayer,
                      self.bufferAnalys,
                      self.layerVisibleAfter
                    ),
                  500
                );
              }
            }
          ],
          layersList: self.layersList
        },
        {
          height: "auto",
          "click-to-close": false,
          classes: ["v--modal", "vue-dialog"]
        },
        {
          "before-open"(event) {
            nameModal = event.name;
          },
          "before-close"(event) {}
        }
      );
    },
    spatialAnalysisIntersection() {
      const self = this;

      let nameModal;
      const template = _.template(templateModalDynamicBase, {
        interpolate: /%%([\s\S]+?)%%/g
      })({
        content: templateAnalysisIntersection
      });
      self.selectedAnalysLayer = false;
      self.selectedAnalysMaskLayer = false;
      self.layerVisibleAfter = false;

      const execut = (layerDef, layerMaskDef, visible) => {
        const layer = layerDef.instance.__value;
        let source = layer.getSource();
        if(source instanceof Cluster) {
          source = source.getSource();
        }

        const layerMask = layerMaskDef.instance.__value;
        let sourceMask = layerMask.getSource();
        if(sourceMask instanceof Cluster) {
          sourceMask = sourceMask.getSource();
        }

        console.log(`spatialAnalysisIntersection START`);
        //tworzenie kolekcji obiektów
        let kolekcja = fabryka.createGeometryCollection(
          _.map(sourceMask.getFeatures(), feature =>
            ol_parser.read(feature.getGeometry())
          )
        );
        console.log(`spatialAnalysisIntersection - wygenerowanie kolekcji`);

        let count = source.getFeatures().length;
        const result = [];
        _.each(source.getFeatures(), (feature, idx) => {
          let geom = ol_parser.read(feature.getGeometry());
          try {
            if(geom.intersects(kolekcja)) {
              const new_feature = feature.clone();
              new_feature.setGeometry(ol_parser.write(geom));
              result.push(new_feature);
            }
          } catch(ex) {
            return;
          }
          if(idx % 100 === 0) {
            console.log(
              `spatialAnalysisIntersection ${(idx / count) * 100}% => ${
              result.length
              }`
            );
          }
        });

        const fields = layerDef.fields.slice();
        const templayer = {
          id: self.$root.generateID(),
          fields,
          geometry_type: layerDef.geometry_type,
          name: `Przecięcie '${layerDef.name}' z '${layerMaskDef.name}'`
        };

        self.$store.commit("addTempLayer", templayer);
        self.$root.$emit("addTempLayer", templayer, result, visible);

        console.log(
          "spatialAnalysisIntersection",
          count,
          result.length,
          templayer.name
        );
        setTimeout(() => {
          self.$root.$emit(
            "showSnackbar",
            "success",
            `Wynikiem jest ${
            result.length
            } obiektów<br/>Warstwa wynikowa to: "${templayer.name}"`
          );
        }, 500);
      };

      self.$modal.show(
        {
          template,
          props: ["title", "buttons", "layersList"],
          data: () => ({
            selectedAnalysLayer: self.selectedAnalysLayer,
            selectedAnalysMaskLayer: self.selectedAnalysMaskLayer,
            layerVisibleAfter: self.layerVisibleAfter
          }),
          methods: {
            updateValue(name, value) {
              if(name in self) {
                self[name] = value;
              }
            }
          }
        },
        {
          title: "Analiza przestrzenna - przecięcie",
          buttons: [
            {
              title: "ANULUJ",
              handler(event) {
                self.$modal.hide(nameModal);
              }
            },
            {
              title: "WYKONAJ",
              handler(event) {
                self.$modal.hide(nameModal);
                self.$root.$emit(
                  "showSnackbar",
                  "#2a579a",
                  "Wykonywanie analizy, prosze czekać"
                );
                setTimeout(
                  () =>
                    execut(
                      self.selectedAnalysLayer,
                      self.selectedAnalysMaskLayer,
                      self.layerVisibleAfter
                    ),
                  500
                );
              }
            }
          ],
          layersList: self.layersList
        },
        {
          height: "auto",
          "click-to-close": false,
          classes: ["v--modal", "vue-dialog"]
        },
        {
          "before-open"(event) {
            nameModal = event.name;
          },
          "before-close"(event) {}
        }
      );
    },
    spatialAnalysisCountInPolygon() {
      const self = this;

      let nameModal;
      const template = _.template(templateModalDynamicBase, {
        interpolate: /%%([\s\S]+?)%%/g
      })({
        content: templateAnalysisCountInPolygon
      });
      self.selectedAnalysLayer = false;
      self.selectedAnalysMaskLayer = false;
      self.layerVisibleAfter = false;

      const execut = (layerDef, layerMaskDef, visible) => {
        const layer = layerDef.instance.__value;
        let source = layer.getSource();
        if(source instanceof Cluster) {
          source = source.getSource();
        }

        const layerMask = layerMaskDef.instance.__value;
        let sourceMask = layerMask.getSource();
        if(sourceMask instanceof Cluster) {
          sourceMask = sourceMask.getSource();
        }

        console.log(`spatialAnalysisCountInPolygon START`);
        //spatial index
        const tree = self.createSpatialIndex(source);

        _.map(source.getFeatures(), feature =>
          ol_parser.read(feature.getGeometry())
        );
        let count = sourceMask.getFeatures().length;
        const result = [];
        _.each(sourceMask.getFeatures(), (feature, idx) => {
          const geom = ol_parser.read(feature.getGeometry());
          try {
            const elements = tree.getContains(geom);
            const new_feature = feature.clone();
            new_feature.set("count_in_polygon", elements.length);
            if(layerDef.geometry_type === "linestring") {
              const total_length = _(elements)
                .map(element => element.feature.getGeometry().getLength())
                .sum()
                .value();
              new_feature.set("total_length_in_polygon", total_length);
            }
            result.push(new_feature);
          } catch(ex) {
            return;
          }
          if(idx % 100 === 0) {
            console.log(
              `spatialAnalysisCountInPolygon ${(idx / count) * 100}% => ${
              result.length
              }`
            );
          }
        });

        const fields = layerMaskDef.fields.slice();
        fields.push({
          data_type: "integer",
          display_name: "Ile elementów",
          name: "count_in_polygon"
        });
        if(layerDef.geometry_type === "linestring") {
          fields.push({
            data_type: "real",
            display_name: "Łączna długość",
            name: "total_length_in_polygon"
          });
        }

        const templayer = {
          id: self.$root.generateID(),
          fields,
          geometry_type: layerMaskDef.geometry_type,
          name: `Zlicz w wielokącie '${layerMaskDef.name}' z '${layerDef.name}'`
        };

        self.$store.commit("addTempLayer", templayer);
        self.$root.$emit("addTempLayer", templayer, result, visible);

        console.log(
          "spatialAnalysisCountInPolygon",
          count,
          result.length,
          templayer.name
        );
        setTimeout(() => {
          self.$root.$emit(
            "showSnackbar",
            "success",
            `Wynikiem jest ${
            result.length
            } obiektów<br/>Warstwa wynikowa to: "${templayer.name}"`
          );
        }, 500);
      };

      self.$modal.show(
        {
          template,
          props: ["title", "buttons", "layersList"],
          data: () => ({
            selectedAnalysLayer: self.selectedAnalysLayer,
            selectedAnalysMaskLayer: self.selectedAnalysMaskLayer,
            layerVisibleAfter: self.layerVisibleAfter
          }),
          methods: {
            updateValue(name, value) {
              if(name in self) {
                self[name] = value;
              }
            },
            itemMaskFilter(item) {
              return item.geometry_type !== "polygon";
            }
          }
        },
        {
          title: "Analiza przestrzenna - zlicz w wielokącie",
          buttons: [
            {
              title: "ANULUJ",
              handler(event) {
                self.$modal.hide(nameModal);
              }
            },
            {
              title: "WYKONAJ",
              handler(event) {
                self.$modal.hide(nameModal);
                self.$root.$emit(
                  "showSnackbar",
                  "#2a579a",
                  "Wykonywanie analizy, prosze czekać"
                );
                setTimeout(
                  () =>
                    execut(
                      self.selectedAnalysLayer,
                      self.selectedAnalysMaskLayer,
                      self.layerVisibleAfter
                    ),
                  500
                );
              }
            }
          ],
          layersList: self.layersList
        },
        {
          height: "auto",
          "click-to-close": false,
          classes: ["v--modal", "vue-dialog"]
        },
        {
          "before-open"(event) {
            nameModal = event.name;
          },
          "before-close"(event) {}
        }
      );
    },
    spatialAnalysis(type) {
      switch(type) {
        case "buffor": //bufor
          this.spatialAnalysisBuffer();
          break;
        case "intersection": //przecięcie
          this.spatialAnalysisIntersection();
          break;
        case "count_in_polygon": //zlicz w poligonie
          this.spatialAnalysisCountInPolygon();
          break;
        default:
          console.log("spatialAnalysis", "Błędne dane", type);
      }
    },

    analysisWaterCutting() {
      this.$root.$emit("toggleLayer", "partitions", true);
      this.$root.$emit("toggleLayer", "watermeters", true);
      this.$root.$emit(
        "attributionDataIncludesID",
        {
          partitions: [],
          watermeters: []
        },
        "partitions",
        "analysis-water-cutting"
      );
    },

    waterUsageInZone() {
      const self = this;

      let nameModal;
      const template = _.template(templateModalDynamicBase, {
        interpolate: /%%([\s\S]+?)%%/g
      })({
        content: templateDialogWaterUsageInZones
      });

      const ds = new Date();
      ds.setDate(1);
      ds.setMonth(ds.getMonth() - 1);
      self.waterUsageStart = ds.toISOString().slice(0, 7);
      self.waterUsageEnd = new Date().toISOString().slice(0, 7);

      function prepareDate(s) {
        return s.replace(new RegExp("([0-9]{4})-([0-9]{2})", "g"), "$1-$2-01");
      }

      const execut = (start, end) => {
        console.log("waterCuttingInZone", start, end);
        if(!start || !end) {
          self.$root.$emit("showSnackbar", "red", "Błędne daty");
          return;
        }

        const payload = {
          start: prepareDate(start),
          end: prepareDate(end),
          token: self.$store.getters.getToken,
          srid: self.$root.projection.split(":")[1]
        };
        fetch(
          `${self.apiURL}/water-usage/geojson?token=${
          payload.token
          }&date_from=${payload.start}&date_from=${payload.end}&srid=${
          payload.srid
          }`
        )
          .then(response =>
            response.status === 200
              ? Promise.resolve(response.json())
              : Promise.reject(response.text())
          )
          .then(geojson => {
            self.$root.$emit(
              "showSnackbar",
              "success",
              "Wygenerowano dane w strefach"
            );

            const templayer = {
              id: self.$root.generateID(),
              fields: [
                {
                  data_type: "text",
                  display_name: "Nazwa strefy",
                  name: "nazwa"
                },
                {
                  data_type: "real",
                  display_name: "Zużycie wody",
                  name: "water_usage"
                }
              ],
              geometry_type: "polygon",
              name: `Strefy, zakres: '${start} - ${end}'`,
              waterUsageInZone: true
            };
            const layer_full_type = `temp_layer_${templayer.name}_${
              templayer.id
              }`;

            self.$store.commit("addTempLayer", templayer);
            const format = new GeoJSON();
            self.$root.$emit(
              "addTempLayer",
              templayer,
              format.readFeatures(geojson),
              true
            );

            const all_layers = _(self.tempLayers)
              .filter(tl => "waterUsageInZone" in tl)
              .map(tl => `temp_layer_${tl.name}_${tl.id}`)
              .keyBy(v => v)
              .mapValues(v => [])
              .value();
            all_layers[layer_full_type] = [];

            this.$root.$emit(
              "attributionDataIncludesID",
              all_layers,
              layer_full_type
            ); //, 'water-usage-in-zone'
          })
          .catch(text => {
            self.$root.$emit("showSnackbar", "red", text);
          });
      };

      self.$modal.show(
        {
          template,
          props: ["title", "buttons"],
          data: () => ({
            waterUsageStart: self.waterUsageStart,
            waterUsageEnd: self.waterUsageEnd,

            startData: "2016-01",
            endData: self.waterUsageEnd
          }),
          methods: {
            updateValue(name, value) {
              if(name in self) {
                self[name] = value;
              }
            }
          }
        },
        {
          title: "Wygeneruj dane w strefach",
          buttons: [
            {
              title: "ANULUJ",
              handler(event) {
                self.$modal.hide(nameModal);
              }
            },
            {
              title: "WYKONAJ",
              handler(event) {
                self.$modal.hide(nameModal);
                self.$root.$emit(
                  "showSnackbar",
                  "#2a579a",
                  "Generowanie prosze czekać"
                );
                setTimeout(
                  () => execut(self.waterUsageStart, self.waterUsageEnd),
                  500
                );
              }
            }
          ]
        },
        {
          height: "auto",
          width: 680,
          "click-to-close": false,
          classes: ["v--modal", "vue-dialog"]
        },
        {
          "before-open"(event) {
            nameModal = event.name;
          },
          "before-close"(event) {}
        }
      );
    },
    computeObstruction() {
      const self = this;

      self.$root.$emit("showSnackbar", "#2a579a", `Trwa wykonywanie analizy`);
      let transformedCoords = transform(
        [self.pointCoords[0], self.pointCoords[1]],
        "EPSG:2180",
        "EPSG:4326"
      );

      self.$store.dispatch("computeClogs", transformedCoords).then(res => {
        if(res.status === 200) {
          if(res.data.manholes && res.data.pipes) {

            //wyświetlenie modelowania
            self.$root.$emit("addModelKan",
              res.data.pipes,
              res.data.manholes
            );

            //<editor-fold defaultstate="collapsed" desc="dodanie warstw tymczasowych dla celów tabeli atrybutów">
            self.layer_full_type = {
              manholes: self.addTempLayer('manholes', res.data.manholes),
              pipes: self.addTempLayer('pipes', res.data.pipes)
            };

            const all_layers = _(self.tempLayers)
              .filter(tl => "modelKan:" in tl)
              .map(tl => `temp_layer_${tl.name}_${tl.id}`)
              .keyBy(v => v)
              .mapValues(v => [])
              .value();
            all_layers[self.layer_full_type.manholes] = [];
            all_layers[self.layer_full_type.pipes] = [];

            this.$root.$emit(
              "attributionDataIncludesID",
              all_layers,
              self.layer_full_type.pipes
            );
            //</editor-fold>


            this.isInactive = false;
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Brak znalezionych danych"
            );
            this.clearObstruction();
          }
        } else {
          this.$root.$emit("showSnackbar", "red", `${res.data.message}`);
        }
        this.pointCoords = undefined;
      });
    },
    clearObstruction() {
      this.$root.$emit("clearModelKan");
      this.$root.$emit("removeMarker");
      this.isInactive = true;
      this.isLocalized = false;
      this.map.getViewport().style.cursor = "";
      this.hideTableData();
      if(Object.keys(this.layer_full_type).length !== 0) {
        this.$root.$emit("deleteLayer", 'temp',
          this.$store.getters.getLayersInstance[this.layer_full_type.manholes]);
        this.$root.$emit("deleteLayer", 'temp',
          this.$store.getters.getLayersInstance[this.layer_full_type.pipes]);
        this.layer_full_type = {};
      }
    },
    addTempLayer(type, geojson) {
      const self = this;
      let fields = [];
      let geometry_type = '';
      let name;

      if(type === 'manholes') {
        fields = [
          {
            data_type: "real",
            display_name: "Dolny",
            name: "bottom"
          },
          {
            data_type: "real",
            display_name: "Wysokość",
            name: "elevation"
          },
          {
            data_type: "real",
            display_name: "Objętość wg",
            name: "volume_acc"
          }
        ];
        geometry_type = "point";
        name = "Studzienki";
      } else if(type === 'pipes') {
        fields = [
          {
            data_type: "integer",
            display_name: "Średnica",
            name: "diameter"
          },
          {
            data_type: "real",
            display_name: "Długość",
            name: "length"
          },
          {
            data_type: "real",
            display_name: "Objętość",
            name: "volume"
          }
        ];
        geometry_type = "linestring";
        name = "przewody";
      }


      const templayer = {
        id: self.$root.generateID(),
        fields,
        geometry_type,
        name: `Model Kanalizacyjny - ${name}`,
        modelKan: true
      };
      const layer_full_type = `temp_layer_${templayer.name}_${templayer.id}`;

      self.$store.commit("addTempLayer", templayer);
      const format = new GeoJSON();
      self.$root.$emit(
        "addTempLayer",
        templayer,
        format.readFeatures(geojson),
        true,
        () => false //pusta stylizacja aby nie było widoczne na mapie a dało sie obsługiwać w tabeli atrybutów
      );

      return layer_full_type;
    },

    toogleShowValvesState() {
      this.$store.commit('setShowValvesState', !this.showValvesState);
      if(this.showValvesState && this.$store.getters.getValvesStateLegend) {
        this.show('valvesStateLegend');
      }
    },
  },
  mounted() {
    this.map.on("singleclick", evt => {
      if(this.isClickable) {
        this.pointCoords = evt.coordinate;
        this.isClickable = false;
        this.isLocalized = true;
        this.$root.$emit("addMarker", evt.coordinate);
        this.map.getViewport().style.cursor = "";
      }
    });
    this.$root.$emit("toggleLayer", "valves", true); //auto właczenie warstwy
    this.$root.$emit("toggleLayer", "partitions", true);

    //console.log(this);
  },
  beforeDestroy() {
    this.clearCutoff();
    this.$store.commit('setShowDirectionFlows', false);
    this.$store.commit('setShowValvesState', false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/analysis/Analysis.vue